import script from "./ChatPlus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPlus.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPlus.vue?vue&type=style&index=0&id=0c3544d3&lang=css"

const __exports__ = script;

export default __exports__